import React, { useState, useEffect } from 'react';
import { Menu, X, Mail, Phone } from 'lucide-react';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Background', href: '#background' },
  { label: 'Contact', href: '#contact' },
  { label: 'Additional Support', href: '#support' },
  { label: 'Resources', href: '#articles' },
  { label: 'Location', href: '#location' },
];


export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ?
      'backdrop-blur-xl bg-[#FAF9F6]/90 shadow-sm border-b border-[#D1D8D0]/50' :
      'bg-[#FAF9F6]/80 backdrop-blur-sm'}`
      }>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-3 lg:py-4">
          {/* Logo / Name */}
          <div className="flex-shrink-0">
            <a
              href="#home"
              onClick={(e) => {e.preventDefault();handleNavClick('#home');}}
              className="block no-underline"
              data-testid="header-logo">

              <h1 className="font-heading text-xl lg:text-2xl font-semibold text-[#2C362A] leading-tight tracking-tight">
                Donna Gordon
              </h1>
              <p className="font-body text-xs text-[#5B6E56] tracking-wide">Psychotherapist, MA

              </p>
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-4 xl:gap-6" data-testid="desktop-nav">
            {navLinks.map((link) =>
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => {e.preventDefault();handleNavClick(link.href);}}
              className="font-body text-xs xl:text-sm text-[#5B6E56] hover:text-[#708A72] transition-colors duration-200 cursor-pointer whitespace-nowrap"
              data-testid={`nav-${link.label.toLowerCase().replace(/ /g, '-').replace(/&/g, 'and')}`}>

                {link.label}
              </a>
            )}
          </nav>

          {/* Contact Info + Mobile Toggle */}
          <div className="flex items-center gap-3">
            <div className="hidden md:flex flex-col items-end gap-0.5">
              <a
                href="mailto:donnagordonpsychotherapy@gmail.com"
                className="flex items-center gap-1.5 font-body text-xs text-[#5B6E56] hover:text-[#708A72] transition-colors"
                data-testid="header-email">

                <Mail size={12} strokeWidth={1.5} />
                donnagordonpsychotherapy@gmail.com
              </a>
              <a
                href="tel:+353894475225"
                className="flex items-center gap-1.5 font-body text-xs text-[#5B6E56] hover:text-[#708A72] transition-colors"
                data-testid="header-phone">

                <Phone size={12} strokeWidth={1.5} />
                +353 89 447 5225
              </a>
            </div>
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="lg:hidden p-2 rounded-lg text-[#5B6E56] hover:bg-[#E6EBE4] transition-colors"
              aria-label="Toggle menu"
              data-testid="mobile-menu-toggle">

              {menuOpen ? <X size={20} strokeWidth={1.5} /> : <Menu size={20} strokeWidth={1.5} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen &&
      <div
        className="lg:hidden bg-[#FAF9F6] border-t border-[#D1D8D0]/50 py-4 px-4 shadow-md"
        data-testid="mobile-menu">

          <nav className="flex flex-col gap-1 mb-4">
            {navLinks.map((link) =>
          <a
            key={link.href}
            href={link.href}
            onClick={(e) => {e.preventDefault();handleNavClick(link.href);}}
            className="font-body text-sm text-[#2C362A] py-2.5 px-3 rounded-lg hover:bg-[#E6EBE4] transition-colors"
            data-testid={`mobile-nav-${link.label.toLowerCase().replace(/ /g, '-')}`}>

                {link.label}
              </a>
          )}
          </nav>
          <div className="border-t border-[#D1D8D0]/50 pt-3 flex flex-col gap-2">
            <a
            href="mailto:donnagordonpsychotherapy@gmail.com"
            className="flex items-center gap-2 font-body text-xs text-[#5B6E56]">

              <Mail size={13} strokeWidth={1.5} />
              donnagordonpsychotherapy@gmail.com
            </a>
            <a
            href="tel:+353894475225"
            className="flex items-center gap-2 font-body text-xs text-[#5B6E56]">

              <Phone size={13} strokeWidth={1.5} />
              +353 89 447 5225
            </a>
          </div>
        </div>
      }
    </header>);

}